/* Galleria a schermo intero della pagina prodotto: si apre dalla copertina o dal pulsante lente. */
(function () {
  if (window.__kojiLightboxBound) return;
  window.__kojiLightboxBound = true;

  var images = [];
  var index = 0;
  var zoomed = false;
  var touchX = null;

  function pathOf(u) {
    try { return new URL(u, location.href).pathname; } catch (e) { return u; }
  }
  function bigUrl(u) {
    try {
      var x = new URL(u, location.href);
      x.searchParams.set('width', '2000');
      return x.toString();
    } catch (e) { return u; }
  }
  function els() {
    var dlg = document.getElementById('koji-lightbox');
    if (!dlg) return null;
    return {
      dlg: dlg,
      img: dlg.querySelector('.koji-lightbox-img'),
      stage: dlg.querySelector('.koji-lightbox-stage'),
      count: dlg.querySelector('.koji-lightbox-count'),
      prev: dlg.querySelector('.koji-lightbox-prev'),
      next: dlg.querySelector('.koji-lightbox-next')
    };
  }

  /* le immagini sono quelle delle miniature; si parte da quella che la pagina mostra adesso */
  function collect() {
    var main = document.getElementById('koji-main-product-img');
    var cur = main ? (main.currentSrc || main.src || '') : '';
    images = [];
    Array.prototype.forEach.call(document.querySelectorAll('.koji-thumb-btn[data-img-url]'), function (t) {
      var u = t.getAttribute('data-img-url');
      if (u) images.push(u);
    });
    var found = -1;
    for (var i = 0; i < images.length; i++) {
      if (pathOf(images[i]) === pathOf(cur)) { found = i; break; }
    }
    if (found < 0 && cur) { images.unshift(cur); found = 0; }
    index = Math.max(found, 0);
  }

  function preload(i) {
    var n = images.length;
    if (n < 2) return;
    [(i + 1) % n, (i - 1 + n) % n].forEach(function (k) {
      var im = new Image();
      im.src = bigUrl(images[k]);
    });
  }

  function show(i) {
    var e = els();
    if (!e || !images.length) return;
    var n = images.length;
    index = ((i % n) + n) % n;
    zoomed = false;
    e.img.classList.remove('is-zoomed');
    e.img.classList.add('is-loading');
    e.img.alt = e.dlg.getAttribute('data-alt') || '';
    e.img.onload = function () { e.img.classList.remove('is-loading'); };
    e.img.onerror = function () { e.img.classList.remove('is-loading'); };
    e.img.src = bigUrl(images[index]);
    if (e.img.complete && e.img.naturalWidth) e.img.classList.remove('is-loading');
    e.count.textContent = n > 1 ? (index + 1) + ' / ' + n : '';
    e.prev.hidden = n < 2;
    e.next.hidden = n < 2;
    e.stage.scrollLeft = 0;
    e.stage.scrollTop = 0;
    preload(index);
  }

  function open() {
    var e = els();
    if (!e || typeof e.dlg.showModal !== 'function') return;
    collect();
    if (!images.length) return;
    show(index);
    if (!e.dlg.open) e.dlg.showModal();
    document.documentElement.classList.add('koji-lightbox-open');
  }

  /* tocco sull'immagine: ingrandisce alla dimensione piena (si scorre con il dito o la rotella), un secondo tocco torna indietro */
  function toggleZoom() {
    var e = els();
    if (!e) return;
    zoomed = !zoomed;
    e.img.classList.toggle('is-zoomed', zoomed);
    if (zoomed) {
      requestAnimationFrame(function () {
        e.stage.scrollLeft = (e.stage.scrollWidth - e.stage.clientWidth) / 2;
        e.stage.scrollTop = (e.stage.scrollHeight - e.stage.clientHeight) / 2;
      });
    }
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (t.closest('.koji-zoom-btn') || t.closest('.koji-product-main-image-wrap.has-zoom .koji-product-main-img')) {
      ev.preventDefault();
      open();
      return;
    }
    var e = els();
    if (!e || !e.dlg.open) return;
    if (t.closest('.koji-lightbox-close')) { e.dlg.close(); }
    else if (t.closest('.koji-lightbox-prev')) { show(index - 1); }
    else if (t.closest('.koji-lightbox-next')) { show(index + 1); }
    else if (t === e.img) { toggleZoom(); }
    else if ((t === e.stage || t === e.dlg) && !zoomed) { e.dlg.close(); }
  });

  /* frecce da tastiera (Esc e il blocco del focus li gestisce il dialog) */
  document.addEventListener('keydown', function (ev) {
    var e = els();
    if (!e || !e.dlg.open) return;
    if (ev.key === 'ArrowLeft') { show(index - 1); }
    else if (ev.key === 'ArrowRight') { show(index + 1); }
  });

  /* swipe laterale per cambiare immagine (non quando è ingrandita: lì il dito serve a scorrere) */
  document.addEventListener('touchstart', function (ev) {
    var e = els();
    touchX = null;
    if (!e || !e.dlg.open || zoomed || ev.touches.length !== 1) return;
    if (!e.dlg.contains(ev.target)) return;
    touchX = ev.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (ev) {
    if (touchX === null) return;
    var dx = ev.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
  }, { passive: true });

  /* alla chiusura: sblocca lo scroll e la copertina della pagina segue l'ultima immagine guardata */
  document.addEventListener('close', function (ev) {
    var dlg = ev.target;
    if (!dlg || dlg.id !== 'koji-lightbox') return;
    document.documentElement.classList.remove('koji-lightbox-open');
    var thumbs = document.querySelectorAll('.koji-thumb-btn[data-img-url]');
    var t = thumbs[index];
    if (t && images.length === thumbs.length && !t.classList.contains('is-active')) t.click();
  }, true);
})();
